import Cookies from 'js-cookie';

const announcementSelector = '.announcement-bar__announcement'
let slideIntervalId

$(function () {
  const $announcementBarRoot = $('.announcement-bar__root');
  const $announcementBar = $('.announcement-bar');

  if (!Boolean(Cookies.get('announcement_hide'))) {
    $announcementBarRoot.slideDown(250, function () {
      if ($announcementBar.length > 0 && $announcementBar.children(announcementSelector).length > 0) {
        const $firstAnnouncement = $announcementBar.find(announcementSelector).first();
        var announcementHeight = parseInt($firstAnnouncement.innerHeight());
        $announcementBar.css('height', announcementHeight + 'px');

        const $announcementCloseBtn = $announcementBar.find('[data-announcement-close]');

        $announcementCloseBtn.on('click', () => {
          $announcementBarRoot.slideUp(250);
          clearInterval(slideIntervalId)
          Cookies.set('announcement_hide', 'true', { expires: 7 });
        });

        if ($announcementBar.children(announcementSelector).length > 1) {
          $firstAnnouncement.clone().attr('data-announcement-index', $announcementBar.children(announcementSelector).length).appendTo($announcementBar);
          const $announcements = $announcementBar.find(announcementSelector);

          $announcements.each(function () {
            $(this).css('height', announcementHeight + 'px');
          });

          var activeIndex = 0;
          slideIntervalId = setInterval(() => {
            activeIndex++;
            if (!$announcementBar.find('[data-announcement-index="' + activeIndex + '"]').length > 0) {
              $announcements.each(function () {
                var transition = $(this).css('transition');
                $(this).css('transition', '0s');
                $(this).css('transform', 'translate3d(0, 0, 0)');

                // setTimeout is used to move the callback out of the stack and into the queue.
                // We need to use the queue to ensure that the transition is restored only after
                // the tansition is complete.
                setTimeout(() => {
                  $(this).css('transition', transition);
                }, 0);
              });

              activeIndex = 1;
            }

            // setTimeout is used to move the callback out of the stack and into the queue.
            // We need to use the queue to ensure that the movement of the elements comes
            // after the position reset.
            setTimeout(() => {
              $announcements.each(function () {
                if ($announcementBar.data('direction') === 'horizontal') {
                  $(this).css('transform', 'translate3d(calc(' + activeIndex + ' * -100%), 0, 0)');
                } else {
                  $(this).css('transform', 'translate3d(0, calc(' + activeIndex + ' * -100%), 0)');
                }
              });
            }, 0);
          }, 5000);
        }
      }
    });
  }
});
